module.exports = __webpack_public_path__ + "img/29.84e089d9.jpg";